<template>
  <div>
    <Card>
      <tables ref="tables" editable v-model="tableData" :columns="columns" @on-delete="handleDelete"/>
      <Pager :total="this.total" @on-page-change="onPageChange"/>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import Pager from '_c/pager'
import { getFileList, syncFileToCos, deleteFile } from '@/api/data'
export default {
  name: 'file_explorer_page',
  components: {
    Tables,
    Pager
  },
  data () {
    let _this = this
    return {
      columns: [
        {
          title: '文件名',
          key: 'filename',
          width: '400px',
          sortable: true,
          render (h, params) {
            return [
              h('Icon', {
                props: {
                  type: 'ios-cloud-done',
                  size: 18,
                  color: params.row.local_exist ? '#000000' : '#ccc'
                },
                attrs: { 'title': params.row.cos ? '已上传云存储' : '' },
                style: params.row.cos ? { 'margin-right': '5px' } : { 'margin-right': '5px', 'color': '#ccc' }
              }),
              h('span', {
                style: params.row.local_exist ? {} : { 'color': '#ccc' },
                attrs: { 'title': params.row.path }
              }, params.row.filename)
            ]
          }
        },
        { title: '大小',
          key: 'size',
          width: '100px',
          sortable: true,
          render (h, params) {
            return h('span', {
              style: params.row.local_exist ? {} : { 'color': '#ccc' },
              attrs: { 'title': params.row.size }
            }, _this.friendlySize(params.row.size))
          }
        },
        { title: '种类',
          key: 'mime',
          width: '150px',
          sortable: true,
          render (h, params) {
            return h('span', {
              style: params.row.local_exist ? {} : { 'color': '#ccc' },
              attrs: { 'title': params.row.mime }
            }, params.row.mime !== '' ? params.row.mime : 'unknown')
          }
        },
        {
          title: '添加日期',
          key: 'created_at',
          sortable: true,
          render (h, params) {
            return h('span', {
              style: params.row.local_exist ? {} : { 'color': '#ccc' }
            }, params.row.created_at)
          }
        },
        {
          title: '操作',
          key: 'handle',
          align: 'center',
          button: [
            (h, params, vm) => {
              return [
                h('Button', {
                  props: {
                    type: 'text',
                    ghost: true
                  },
                  on: {
                    click: () => {
                      let title = params.row.filename
                      this.$Modal.confirm({
                        title: '你确定要同步到云存储吗?',
                        content: `<p>同步<b style="margin-left:5px">${title}</b>到腾讯云存储</p>`,
                        onOk: () => {
                          // console.log('++++>', )
                          syncFileToCos(params.row.id, 'qcloud').then(resp => {
                            if (resp.data.ok) {
                              this.$Message.info('同步成功')
                              this.onPageChange(this.page)
                            } else {
                              this.$Message.warning('同步失败')
                            }
                          })
                        },
                        onCancel: () => {
                          this.$Message.info('Clicked cancel')
                        }
                      })
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-sync',
                      size: 18,
                      color: params.row.local_exist ? '#000000' : '#ccc'
                    }
                  })
                ]),
                h('Button', {
                  props: {
                    type: 'text',
                    ghost: true
                  },
                  on: {
                    click: () => {
                      if (params.row.article_ref_count > 0) {
                        this.$Message.info(`文件被${params.row.article_ref_count}篇文章引用，不能删除`)
                        return
                      }
                      if (params.row.cover_ref_count > 0) {
                        this.$Message.info(`文件被${params.row.cover_ref_count}个封面引用，不能删除`)
                        return
                      }

                      let title = params.row.filename
                      this.$Modal.confirm({
                        title: '你确定要删除吗?',
                        content: `<p>删除<b style="margin-left:5px">${title}</b></p>`,
                        onOk: () => {
                          deleteFile(params.row.id).then(resp => {
                            if (resp.data.ok) {
                              this.$Message.success('删除成功')
                              this.onPageChange(this.page)
                            } else {
                              this.$Message.warning('删除失败')
                            }
                          })
                        },
                        onCancel: () => {
                          this.$Message.info('取消')
                        }
                      })
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-trash',
                      size: 18,
                      color: '#000000'
                    }
                  })
                ])
              ]
            }
          ]
        }
      ],
      tableData: [],
      total: 0,
      page: 1
    }
  },
  methods: {
    handleDelete (params) {
      console.log(params)
      return false
    },
    onPageChange (page) {
      this.page = page
      getFileList(page, 10).then(res => {
        if (res.data.ok) {
          console.log('list -->', res.data.list)
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    },
    friendlySize (size) {
      if (size >= 1024 * 1024 * 1024 * 1024) {
        return Math.round((size / 1024 / 1024 / 1024 / 1024) * 100) / 100 + 'G'
      }
      if (size >= 1024 * 1024 * 1024) {
        return Math.round((size / 1024 / 1024 / 1024) * 100) / 100 + 'M'
      }
      if (size >= 1024 * 1024) {
        return Math.round((size / 1024 / 1024) * 100) / 100 + 'K'
      }
      if (size >= 1024) {
        return Math.round((size / 1024) * 100) / 100 + 'K'
      }
      if (size < 1024) {
        return size + 'B'
      }
    }
  },
  mounted () {
    getFileList(1, 10).then(res => {
      if (res.data.ok) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    })
  }
}
</script>

<style scoped>

</style>
